
import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../primitives';
import { REVISIONED_LINE_ITEM_TYPES, RevisionedLineItemTypeSchema } from './revisioned-line-item-type-schema';

export const NewRevisionedLineItemSchema = oz.object({
  type: RevisionedLineItemTypeSchema,
  name: oz.string(),
  description: oz.string().nonempty().optional(),
  price: oz.number().optional(),
  baseLineItemId: ObjectIdSchema.optional(),
  invoiceId: ObjectIdSchema,
  percentage: oz.number().nonnegative().optional(),
}).openapi('NewRevisionedLineItem');

export type NewRevisionedLineItem = oz.infer<typeof NewRevisionedLineItemSchema>;

export const percentagePromotionLineItemSchema = NewRevisionedLineItemSchema.extend({
  type: oz.literal(REVISIONED_LINE_ITEM_TYPES.PercentagePromotion),
  percentage: oz.number().nonnegative(),
}).openapi('NewPercentagePromotionRevisionedLineItem');
export type NewPercentagePromotionRevisionedLineItem = oz.infer<typeof percentagePromotionLineItemSchema>;

export const fixedRevisionedLineItemSchema = NewRevisionedLineItemSchema.extend({
  type: oz.union([
    oz.literal(REVISIONED_LINE_ITEM_TYPES.Fixed),
    oz.literal(REVISIONED_LINE_ITEM_TYPES.Usage),
    oz.literal(REVISIONED_LINE_ITEM_TYPES.FixedPromotion),
  ]),
  price: oz.number().nonnegative(),
}).openapi('FixedNewRevisionLineItem');

export type NewFixedRevisionedLineItem = oz.infer<typeof fixedRevisionedLineItemSchema>;
